import DocsTaskDetail from './styled';

export default DocsTaskDetail;
